(function() {
    'use strict';

    var mainId = $('main').attr('id');
    $('.main-menu li#' + mainId).addClass('current');

    if (mainId === 'index') {
        $('.main-menu li#capsules').addClass('current');
    }
})();